const translations = {
    applicationDate: 'Application Date'
};

export default translations;
